import React from 'react';
import { motion } from 'framer-motion';
export function EmpathySection() {
  return <section className="py-12 md:py-20 px-4 md:px-6 bg-[var(--bg-surface)]" data-id="element-83">
      <div className="max-w-[720px] mx-auto" data-id="element-84">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-5 md:space-y-8" data-id="element-85">
          <h2 className="text-2xl md:text-4xl font-serif text-[var(--text-heading)] text-center leading-tight" data-id="element-86">
            Is it 6:00 PM again?
          </h2>

          <div className="space-y-4 md:space-y-6 text-base md:text-xl text-[var(--text-primary)] leading-relaxed font-light" data-id="element-87">
            <p data-id="element-88">
              Are you standing in your kitchen, staring at the only brand of
              chicken nuggets your child will eat, praying they haven't changed
              the recipe?
            </p>

            <div className="bg-[var(--bg-card)] p-6 md:p-8 rounded-xl border border-[var(--border-subtle)] shadow-sm" data-id="element-89">
              <p className="text-lg md:text-2xl font-serif text-[var(--accent)] text-center italic leading-snug" data-id="element-90">
                You’re exhausted. You’ve tried "the one-bite rule." You’ve tried
                hiding vegetables in the pasta.
              </p>
            </div>

            <p data-id="element-91">
              You’ve even tried the{' '}
              <strong className="text-[var(--text-heading)] font-semibold" data-id="element-92">
                "if they are hungry enough, they will eat"
              </strong>{' '}
              advice from people who clearly don't understand autism.
            </p>

            <div className="border-l-4 border-[var(--accent)] pl-5 md:pl-6 py-2 my-4" data-id="element-93">
              <p className="font-serif italic text-[var(--text-heading)] text-lg md:text-xl" data-id="element-94">
                "It feels like a daily battle you can't win, and the guilt of
                watching them eat the same beige foods every single day is
                overwhelming."
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}